define([
    "./nlgMultiSelectModule",
    "./nlgMultiSelectDirective"
], function () {
});
